
import React, { useRef, useState } from 'react';

import { useCarContext } from '../components/Context/CarContext';
import { useSnackbar } from './SnackBar';
import { Box, Button, Grid, TextField, Typography } from '@mui/material'
import { useProgressBar } from './ProgressBar';

const BrandForm = () => {
    const { AddBrands } = useCarContext();
    const { showSnackbar } = useSnackbar();
    const brandRef = useRef(null);
    const iconRef = useRef(null);
    const fileRef=useRef(null);
    const { showProgress } = useProgressBar();
    const [selectedFile, setSelectedFile] = useState(null);
    const [fileFormatType,setFileFormatType]=useState(false);
    const [fileFormatSize,setFileFormatSize]=useState(false);
    const checkFileFormat=async (event)=> {
        const maxSize = 5 * 1024 * 1024;
        const validFileTypes=['image/jpeg', 'image/png'];
        const ftype=event.target.files[0];
        if(fileFormatSize && fileFormatSize!== undefined){
            fileFormatSize=ftype.size;
        }
        if(fileRef.current.value!=""){
        if(!validFileTypes.includes(ftype.type)){
                setFileFormatType(true)
            }else{
                setFileFormatType(false)
            }
        }
        if(fileFormatSize>maxSize){
            setFileFormatSize(true) 
        }else{
            setFileFormatSize(false)
        }

    };
    // Function to handle file selection
    const handleFileChange = (event) => {
        setSelectedFile(event.target.files[0]); // Get the first selected file
    };
    const formRef=useRef([]);
    const handleClick=()=>{
        const formElements=formRef.current;
        for(let element of formElements){
            if(element.tagName==='INPUT' && element.type!='button'){

                if(element.value===''){
                    element.style.borderColor='red';
                }else{
                    element.style.borderColor='';
                }

            }
            
        }
    }

    const checkEmptyField = (e) => { 
        if (!e) return; 
         const element = e.target; 
         if (element.type === 'file') { 
            if (element.files.length === 0) { 
                e.target.style.borderColor = ''; 
            } else{ 
                e.target.style.borderColor = ''; 
            } 
        } 
             if (element.tagName === 'INPUT') { 
                if (element.value === '') {
                     e.target.style.borderColor = ''; 
                } else 
                { e.target.style.borderColor = ''; 

                } 
            }
    }
    const handleAddBrand = async () => {
        if (brandRef.current.value.trim() === '' || selectedFile == null) {
            showSnackbar('Brand Name/icon cannot be blank', 'error');
            handleClick();
            return;
        } else {
            showProgress(true);
            await AddBrands({ id: 0, name: brandRef.current.value.trim(), icon: "" }, selectedFile);
            showProgress(false);
            showSnackbar('This is a test message', 'warning');

        }

       
    };
    
    return (
        <div>
        <form ref={formRef}>
            <div className="row mb-3">
                <label htmlFor="icon" className="col-sm-2 col-form-label">Brand Name</label>
                <div className="col-sm-10">
                    <input type="text" ref={brandRef}  className="form-control" onBlur={(e)=>{checkEmptyField(e);}}/>
                </div>
            </div>

            
                <div className="row mb-3">
                    <label htmlFor="inputNumber" className="col-sm-2 col-form-label">File Upload</label>
                    <div className="col-sm-10">
                        <input className="form-control" type="file" id="formFile" onChange={handleFileChange}  ref={fileRef} onBlur={(e)=>{checkEmptyField(e); checkFileFormat(e);}}/>
                    {fileFormatType==true&&(<div className="form-text text-danger">{ fileFormatType==true ? "Invalid file type. Please upload an image file (jpeg, png).":"" }</div>)}{fileFormatSize==true&&(<div className="form-text text-danger">{ fileFormatSize==true ? "File size too large. Please upload a file smaller than 5MB.":"" }</div>)}
                    </div>
                </div>


                <div className="text-left">
                    <label htmlFor="icon" className="col-sm-2 col-form-label"></label>
                    <button type="button" onClick={handleAddBrand} className="btn btn-primary blue-button">Save</button>

            </div>

        </form>

        
            {/*<form>*/}
            {/*    <Box mb={3} textAlign="center">*/}
            {/*        <Grid container alignItems="center" spacing={2} justifyContent="center">*/}
            {/*            <Grid item>*/}
            {/*                <Typography variant="body1">Brand Name:</Typography>*/}
            {/*            </Grid>*/}
            {/*            <Grid item>*/}
            {/*                <TextField*/}
            {/*                    inputRef={brandRef}*/}
            {/*                    placeholder="Brand Name"*/}
            {/*                    variant="outlined"*/}
            {/*                    size="small"*/}
            {/*                />*/}
            {/*            </Grid>*/}
            {/*        </Grid>*/}
            {/*    </Box>*/}
            {/*    <Box mb={3} textAlign="center">*/}
            {/*        <Grid container alignItems="center" spacing={2} justifyContent="center">*/}
            {/*            <Grid item>*/}
            {/*                <Typography variant="body1">Brand Icon:</Typography>*/}
            {/*            </Grid>*/}
            {/*            <Grid item>*/}
            {/*                <TextField*/}
            {/*                    inputRef={iconRef}*/}
            {/*                    placeholder="Brand Icon"*/}
            {/*                    variant="outlined"*/}
            {/*                    size="small"*/}
            {/*                />*/}
            {/*            </Grid>*/}
            {/*        </Grid>*/}
            {/*    </Box>*/}
            {/*    <Box textAlign="center">*/}
            {/*        <Button*/}
            {/*            variant="contained"*/}
            {/*            color="primary"*/}
            {/*            onClick={handleAddBrand}*/}
            {/*        >*/}
            {/*            Save*/}
            {/*        </Button>*/}
            {/*    </Box>*/}
            {/*</form>*/}
            </div>
    );
};

export default BrandForm;
